import { useEffect, useState } from 'react';
import { api } from '../api/client';

/** Общий кэш фото целей — переживает перемонтирование и шарится между экранами. */
export const imageCache = new Map<string, string | null>();

/** Лениво подгружает data-url фото цели (по имени) с кэшем; null — если фото нет/офлайн. */
export function useGoalImage(name: string, hasImage: boolean): string | null {
  const [img, setImg] = useState<string | null>(imageCache.get(name) ?? null);

  useEffect(() => {
    if (!hasImage) {
      setImg(null);
      return;
    }
    if (imageCache.has(name)) {
      setImg(imageCache.get(name) ?? null);
      return;
    }
    let cancelled = false;
    api
      .getGoalImage(name)
      .then((r) => {
        imageCache.set(name, r.image);
        if (!cancelled) setImg(r.image);
      })
      .catch(() => {
        /* офлайн — рисуем без фото */
      });
    return () => {
      cancelled = true;
    };
  }, [name, hasImage]);

  return img;
}
